import * as React from "react";
import classNames from "classnames";
import { Input, Tooltip, Typography, withStyles } from "@material-ui/core";

const styles = () => ({
  root: {
    width: "100%",
    overflow: "hidden",
  },
  label: {
    fontSize: 11,
    marginTop: 10,
    marginBottom: 1,
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  input: {
    fontFamily: "Roboto",
    padding: 0,
    "&::after": {
      borderBottom: "1px solid !important",
    },
  },
  text: {
    color: "#AAAAAB",
    background: "transparent",
    width: "93%",
    "&:hover": {
      borderBottom: "1px dotted #fff !important",
    },
  },
});

interface IProps {
  classes: any;
  value: string;
  label: string;
  canEdit?: boolean;
  margin?: boolean;
  disabled?: boolean;
  onEnableEdit?: () => void;
  onInputChange?: (newValue: string) => void;
  onInputBlur?: (newValue: string) => void;
}

const EditableLabel = ({
  classes,
  value,
  label,
  canEdit = true,
  margin = false,
  disabled = false,
  onEnableEdit = () => {},
  onInputChange = () => {},
  onInputBlur = () => {},
}: IProps) => {
  const [edit, setEdit] = React.useState(false);
  const [newValue, setNewValue] = React.useState(value);
  const [inputRef, setInputRef] = React.useState<HTMLInputElement | undefined>(
    undefined
  );

  const handleClickLabel = (event) => {
    if (canEdit) {
      onEnableEdit();
      setNewValue(value);
      setEdit(true);
      setTimeout(() => {
        if (inputRef) {
          inputRef.focus();
          inputRef.select();
        }
      }, 500);
    }

    event.stopPropagation();
  };

  const handleChangeInput = (ev) => {
    const { value } = ev.target;
    setNewValue(value);
    onInputChange(value);
  };

  const handleBlurInput = (ev) => {
    onInputBlur(newValue);
    setEdit(false);
  };

  return (
    <div
      className={classes.root}
      style={{
        width: "100%",
        overflow: "hidden",
        marginLeft: margin ? "0px" : "10px",
      }}
    >
      {edit ? (
        <label
          ref={(node: HTMLLabelElement | null) => {
            if (node && node.childNodes[0]) {
              setInputRef(node.childNodes[0].childNodes[0] as HTMLInputElement);
            } else setInputRef(undefined);
          }}
        >
          <Input
            classes={{ input: classNames(classes.label, classes.input) }}
            defaultValue={newValue}
            placeholder={label}
            onChange={handleChangeInput}
            onBlur={handleBlurInput}
            disabled={disabled}
          />
        </label>
      ) : (
        <Tooltip title={value}>
          <Typography
            id="rateLibName"
            component="span"
            className={classNames(classes.label, classes.text)}
            onDoubleClick={handleClickLabel}
          >
            {value}
          </Typography>
        </Tooltip>
      )}
    </div>
  );
};

export default withStyles(styles)(EditableLabel);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ModelMapItem/EditableLabel.tsx